import Route from './forum-routes'

export { Route }
export default { Route }
